import { createFileRoute } from '@tanstack/react-router'

import { MerchantProfileScreen } from './-components/merchant-profile-screen.tsx'

export const Route = createFileRoute('/risk/merchant-profile')({
  component: MerchantProfileScreen
})
